import React from 'react'

import { Subnav as TideSubnav } from '@driftt/tide-subnav'
import { access } from '@driftt/traffic-control'

const Subnav = ({ appConfig }: any) => {
  const { hasContacts, hasAccounts, hasLiveView } = appConfig
  const { hasGates, isBot } = access

  const hasSegmentsAccess = () => hasGates('has_segments_access') || isBot()

  const audienceNodes = {
    label: 'Audiences',
    path: '/',
  }

  const segmentNodes = {
    label: 'Segments',
    path: '/segments',
    external: true,
    hide: !hasSegmentsAccess(),
  }

  const contactNodes = {
    label: 'CONTACTS',
    hide: !hasContacts,
    expanded: true,
    nodes: [
      {
        label: 'All contacts',
        path: '/contacts',
        external: true,
      },
      {
        label: 'Contact segments',
        path: '/contacts/segments',
        external: true,
      },
      {
        label: 'Import contacts',
        path: '/contacts/imports',
        external: true,
      },
      {
        label: 'Contacts settings',
        path: '/contacts/contact-settings',
        external: true,
      },
    ],
  }

  const accountNodes = {
    label: 'ACCOUNTS',
    hide: !hasAccounts,
    expanded: true,
    nodes: [
      {
        label: 'All accounts',
        path: '/accounts',
        hide: !hasAccounts,
        external: true,
      },
      {
        label: 'Account segments',
        path: '/accounts/segments',
        hide: !hasAccounts,
        external: true,
      },
      {
        label: 'Import accounts',
        path: '/accounts/imports',
        hide: !hasAccounts,
        external: true,
      },
    ],
  }

  const liveViewNodes = {
    label: 'Live view',
    hide: !hasLiveView,
    path: '/live',
    external: true,
  }

  const subNavNodes = [
    audienceNodes,
    segmentNodes,
    contactNodes,
    accountNodes,
    liveViewNodes,
  ]
  return (
    <>
      <TideSubnav
        title="Visitors"
        className="audiences-subnav"
        open
        nodes={subNavNodes}
      />
    </>
  )
}

export default Subnav
